import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import { getInlineLoader } from "../../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaChartLine,
  FaCalculator,
  FaUserShield,
  FaNetworkWired,
  FaTools
} from "react-icons/fa";

import banner1 from "../../assets/banner1.png";
import banner2 from "../../assets/banner2.png";
import banner3 from "../../assets/banner3.jpg";
import banner4 from "../../assets/banner4.png";
import banner5 from "../../assets/banner2.jpg";

export default function ServicesBanner1() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: false,
      offset: 50
    });
  }, []);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  const services = [
    { 
      title: "Financial Management", 
      icon: <FaChartLine />, 
      desc: "High-level fiscal logic for real-time institutional capital tracking and performance analytics.", 
      image: banner1 
    },
    { 
      title: "Accounting Systems", 
      icon: <FaCalculator />, 
      desc: "Automated bookkeeping and fiscal reconciliation engines built for enterprise-scale compliance.", 
      image: banner2 
    },
    { 
      title: "CRM Solutions", 
      icon: <FaUserShield />, 
      desc: "Intelligent stakeholder management with unified data streams and secure SSID integration.", 
      image: banner3 
    },
    { 
      title: "ERP Integration", 
      icon: <FaNetworkWired />, 
      desc: "Centralized resource planning connecting departmental silos into a high-level logic ecosystem.", 
      image: banner4 
    },
    { 
      title: "Custom Business Tools", 
      icon: <FaTools />, 
      desc: "Proprietary BizSuite solutions engineered for unique institutional workflows and complex logic.", 
      image: banner5 
    }
  ];

  return (
    <section className="MainBodySection py-5 position-relative overflow-hidden" style={{ background: '#fcfcfd' }}>
      <div className="container position-relative" style={{ zIndex: 1, maxWidth: '1200px' }}>
        
        {/* Header Section */}
        <div className="row justify-content-center mb-5 pt-4">
          <div className="col-lg-8 text-center">
            <h6 className="text-primary fw-bold text-uppercase mb-3 tracking-widest" data-aos="fade-up">Enterprise Solutions</h6>
            <h2 className="font-bold mb-4" data-aos="fade-up" style={{ 
              fontSize: 'clamp(2.3rem, 5vw, 3.2rem)', 
              color: 'var(--primaryColor)',
              lineHeight: 1.1,
              letterSpacing: '-0.02em'
            }}>
              Systems Engineered for <br/>
              <span style={{ color: 'var(--secondaryColor)' }}>Institutional Growth</span>
            </h2>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row g-4 mb-5 justify-content-center">
          {services.map((svc, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 mt-3" data-aos="fade-up" data-aos-delay={idx * 100}>
              <div className="service-card h-100 rounded-1 position-relative overflow-hidden border-0 shadow-sm" style={{ 
                minHeight: '420px',
                background: `linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(15,15,35,0.92)), url(${svc.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)'
              }}>
                
                {/* Header UI: Badge & Icon Separation */}
                <div className="d-flex justify-content-between align-items-start p-4 w-100 position-relative" style={{ zIndex: 2 }}>
                  
                  <div className="service-icon-wrapper d-flex align-items-center justify-content-center" style={{
                    width: '50px',
                    height: '50px',
                    background: 'rgba(255, 255, 255, 0.12)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    fontSize: '1.2rem',
                    transition: 'all 0.4s ease'
                  }}>
                    {svc.icon}
                  </div>
                </div>

                {/* Content */}
                <div className="position-absolute bottom-0 start-0 w-100 px-4 pb-4" style={{ zIndex: 2 }}>
                  <h3 className="text-white fw-bold mb-2 h5" style={{ letterSpacing: '-0.01em' }}>{svc.title}</h3>
                  <p className="text-light opacity-75 mb-0" style={{ lineHeight: '1.6', fontSize: '0.88rem', fontWeight: '300' }}>
                    {svc.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .service-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 30px 60px rgba(0,0,0,0.25) !important;
        }
        .service-card:hover .service-icon-wrapper {
          background: var(--secondaryColor);
          border-color: var(--secondaryColor);
          transform: translateY(-2px) rotate(360deg);
        }
        .service-card::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: var(--secondaryColor);
          transform: scaleX(0);
          transition: transform 0.4s ease;
          transform-origin: left;
          z-index: 3;
        }
        .service-card:hover::after {
          transform: scaleX(1);
        }
      `}</style>
    </section>
  );
}